import { useCallback, useEffect, useRef, useState } from 'react';

const FALLBACK_HOST = 'marthe.flower.agency';

function getShareUrl(): string {
  if (typeof window === 'undefined') return `https://${FALLBACK_HOST}/send`;
  return `${window.location.origin}/send`;
}

function getShareLabel(): string {
  if (typeof window === 'undefined') return `${FALLBACK_HOST}/send`;
  const host = window.location.host || FALLBACK_HOST;
  return `${host}/send`;
}

export function ShareLinkBar() {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const onShare = useCallback(async () => {
    const url = getShareUrl();
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(url);
      } else {
        // fallback : selection range
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      setError(null);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      setCopied(false);
      setError(e instanceof Error ? e.message : 'copie échouée');
    }
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div className="chat-share-bar" data-testid="share-link-bar">
      <button
        type="button"
        className="chat-share-bar__btn"
        onClick={onShare}
        data-testid="share-link-btn"
        aria-live="polite"
      >
        {copied ? '✓ lien copié' : '→ partager le lien'}
      </button>
      <span className="chat-share-bar__url">{getShareLabel()}</span>
      {error && <span className="chat-share-bar__error">✗ {error}</span>}
    </div>
  );
}
